import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import l10n from '../../../lang/locallang';

const tableSection = (param, is_public = false) => {
    const { heading, column } = l10n.editor;
    param.class = param.class ? param.class : 'editor-section editor-table';
    param.layout = param.layout ? param.layout : '';
    param.style = param.style ? param.style : '';
    param.section = 'tableSection';
    let content = param.content && param.content.text ? param.content.text : `<table>
            <thead>
                <tr>
                    <th style="width: 50%;">${heading} 1</th>
                    <th style="width: 50%;">${heading} 2</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="width: 50%;"><p>${column} 1</p></td>
                    <td style="width: 50%;"><p>${column} 2</p></td>
                </tr>
                <tr>
                    <td style="width: 50%;"><p>${column} 1</p></td>
                    <td style="width: 50%;"><p>${column} 2</p></td>
                </tr>
            </tbody>
        </table>`;
    param.component = `<div class="table-container">${content}</div> `;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {tableSection};
